import React from 'react';
import { makeStyles } from "@mui/styles";
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { FadingBalls } from "react-cssfx-loading";

export const NavDrawer = (props) => {
    const classes = useStyles();

    const { t } = useTranslation();



    return (
        <div style={{ height: '100%', width: '100%', position: 'fixed', top: '0', zIndex: 997 }}>
            <div className={classes.loadingBackground}>
            </div>
            <div className={classes.loadingContainer}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <div className={classes.loadingCharts}>{props.loadingText !== "" && props.loadingText !== null && props.loadingText !== undefined ? props.loadingText : t("Laden")}</div>
                    <FadingBalls color={"#84bd40"} width="4rem" height="1em"></FadingBalls>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    loadingBackground: {
        height: "100%",
        width: '100%',
        zIndex: '1300',
        backgroundColor: 'black',
        opacity: '0.5',
        top: '0',
        position: 'fixed'
    },
    loadingContainer: {
        top: '0',
        zIndex: '1301',
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center",
        height: "100%",
        width: '100%',
    },
    loadingCharts: {
        marginBottom: '20px',
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: "Lato, sans-serif",
        color: "#84bd40",
        textAlign: 'center'

    },
}));

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        user: state.user,

    }
}

export default connect(mapStateToProps)(NavDrawer)